import { createWebHistory, createRouter } from "vue-router";

import LoginView from "@/components/views/LoginView.vue";
import DashboardView from "@/components/views/private/DashboardView.vue";
import PerfilView from "@/components/views/private/PerfilView.vue";
import SolicitudReunionView from "@/components/views/private/SolicitudReunionView.vue";
import AgendaView from "@/components/views/private/AgendaView.vue";
import BloqueoHorarioView from "@/components/views/private/BloqueoHorarioView.vue";
import MensajesView from "@/components/views/private/MensajesView.vue";
import PageNotFoundView from "@/components/views/PageNotFoundView.vue";
import RegistroInvitacionEmpresaView from "@/components/views/RegistroInvitacionEmpresaView.vue";

/**
 * Seguridad
 */
import seguridadServices from "@/services/seguridad.services";
import { ConfiguracionMeeting } from "qreventos-suite/src/services/suite.interfaces";
import configuracionMeetingService from "@/services/configuracion.merting.services";
import Swal from 'sweetalert2'

const routes = [
  {
    path: "/:context",
    name: "Login",
    component: LoginView,
    meta: { hideLayout: true }
  },
  {
    path: "/:context/registro/:hashEmpresa",
    name: "Registro",
    component: RegistroInvitacionEmpresaView,
    meta: { hideLayout: true }
  },
  {
    path: "/private/dashboard",
    name: "menu.dashboard",
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: "/private/perfil",
    name: "menu.mi.perfil",
    component: PerfilView,
    meta: { requiresAuth: true }
  },
  {
    path: "/private/agenda",
    name: "menu.agenda",
    component: AgendaView,
    meta: { requiresAuth: true }
  },
  {
    path: "/private/solicitudReuniones",
    name: "menu.solicitar.reunion",
    component: SolicitudReunionView,
    meta: { requiresAuth: true }
  },
  {
    path: "/private/bloqueoHorario",
    name: "menu.bloquear.horario",
    component: BloqueoHorarioView,
    meta: { requiresAuth: true }
  },
  {
    path: "/private/mensajes",
    name: "menu.mensajes",
    component: MensajesView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:catchAll(.*)",
    component: PageNotFoundView,
    meta: { hideLayout: true }
  },
  {
    path: "/private/:catchAll(.*)",
    component: PageNotFoundView
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const hash:string = seguridadServices.getLocalHash() as string;
    if (hash) {
      next();
    } else {
      Swal.fire({ title: "¡Atención!", html: "Sesión expirada", icon: "warning" }).then(() => {
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        seguridadServices.logout();
        next({ path: '/' + configuracionMeeting.contextUrl });
        configuracionMeetingService.remove();
      });
    }
  } else {
    next();
  }
});

export default router;
